import { useState } from 'react';
import AccessControl from '../components/AccessControl';

export default function Settings() {
  const [commission, setCommission] = useState(20);
  const [minFare, setMinFare] = useState(50);
  const [perKm, setPerKm] = useState(12);
  const [surgeEnabled, setSurgeEnabled] = useState(true);
  const [notifications, setNotifications] = useState(true);
  const [autoAssign, setAutoAssign] = useState(true);

  const Toggle = ({ value, onChange }) => (
    <div
      onClick={() => onChange(!value)}
      style={{
        width: 42, height: 24, borderRadius: 12, cursor: 'pointer',
        background: value ? '#1D9E75' : '#ddd',
        position: 'relative', transition: 'background 0.2s',
        flexShrink: 0,
      }}
    >
      <div style={{
        width: 18, height: 18, borderRadius: '50%', background: 'white',
        position: 'absolute', top: 3, left: value ? 21 : 3,
        transition: 'left 0.2s', boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
      }} />
    </div>
  );

  const SettingRow = ({ label, sub, children }) => (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '14px 0', borderBottom: '1px solid #f0f0ec' }}>
      <div>
        <div style={{ fontSize: 13, fontWeight: 500, color: '#1a1a1a' }}>{label}</div>
        {sub && <div style={{ fontSize: 12, color: '#888', marginTop: 2 }}>{sub}</div>}
      </div>
      {children}
    </div>
  );

  return (
    <div>
<AccessControl
        allowedRoles={["SUPERADMIN", "ADMIN","HR", "NSM", "RSM", "ASM", "TSO"]}
        redirectTo="/404"
      />
      <div className="grid-2" style={{ alignItems: 'start' }}>
        {/* Fare Settings */}
        <div className="card section">
          <div className="card-header">
            <span className="card-title">Fare Configuration</span>
          </div>

          <SettingRow label="Platform Commission" sub="Percentage deducted from each ride">
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <input
                type="number"
                value={commission}
                onChange={e => setCommission(e.target.value)}
                style={{ width: 70, padding: '6px 10px', border: '1px solid #e8e8e4', borderRadius: 8, fontSize: 13, textAlign: 'center' }}
              />
              <span style={{ fontSize: 13, color: '#888' }}>%</span>
            </div>
          </SettingRow>

          <SettingRow label="Minimum Fare" sub="Base fare for any ride">
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={{ fontSize: 13, color: '#888' }}>₹</span>
              <input
                type="number"
                value={minFare}
                onChange={e => setMinFare(e.target.value)}
                style={{ width: 70, padding: '6px 10px', border: '1px solid #e8e8e4', borderRadius: 8, fontSize: 13, textAlign: 'center' }}
              />
            </div>
          </SettingRow>

          <SettingRow label="Per KM Rate" sub="Fare charged per kilometer">
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={{ fontSize: 13, color: '#888' }}>₹</span>
              <input
                type="number"
                value={perKm}
                onChange={e => setPerKm(e.target.value)}
                style={{ width: 70, padding: '6px 10px', border: '1px solid #e8e8e4', borderRadius: 8, fontSize: 13, textAlign: 'center' }}
              />
              <span style={{ fontSize: 13, color: '#888' }}>/km</span>
            </div>
          </SettingRow>

          <SettingRow label="Surge Pricing" sub="Enable dynamic pricing during peak hours">
            <Toggle value={surgeEnabled} onChange={setSurgeEnabled} />
          </SettingRow>

          <div style={{ marginTop: 16 }}>
            <button className="btn btn-success" style={{ width: '100%' }}>Save Fare Settings</button>
          </div>
        </div>

        {/* App Settings */}
        <div>
          <div className="card section">
            <div className="card-header">
              <span className="card-title">App Settings</span>
            </div>

            <SettingRow label="Push Notifications" sub="Send alerts to drivers & users">
              <Toggle value={notifications} onChange={setNotifications} />
            </SettingRow>

            <SettingRow label="Auto Assign Driver" sub="Automatically assign nearest driver">
              <Toggle value={autoAssign} onChange={setAutoAssign} />
            </SettingRow>

            <SettingRow label="App Version" sub="Current deployed version">
              <span className="badge badge-blue">v1.0.0</span>
            </SettingRow>

            <div style={{ marginTop: 16 }}>
              <button className="btn-outline-green" style={{ width: '100%' }}>Save App Settings</button>
            </div>
          </div>

          <div className="card section">
            <div className="card-header">
              <span className="card-title">Admin Profile</span>
            </div>

            {[
              { label: 'Name', placeholder: 'Admin Name', defaultValue: 'Moovuruli Admin' },
              { label: 'Email', placeholder: 'admin@moovuruli.com', defaultValue: 'admin@moovuruli.com' },
              { label: 'Phone', placeholder: '+91 XXXXX XXXXX', defaultValue: '+91 98765 00000' },
            ].map(f => (
              <div key={f.label} style={{ marginBottom: 14 }}>
                <div style={{ fontSize: 12, color: '#888', marginBottom: 5, fontWeight: 500 }}>{f.label}</div>
                <input
                  type="text"
                  defaultValue={f.defaultValue}
                  placeholder={f.placeholder}
                  style={{ width: '100%', padding: '8px 12px', border: '1px solid #e8e8e4', borderRadius: 8, fontSize: 13, color: '#333', outline: 'none' }}
                />
              </div>
            ))}

            <button className="btn btn-success" style={{ width: '100%', marginTop: 4 }}>Update Profile</button>
          </div>
        </div>
      </div>

      {/* Danger Zone */}
      <div className="card" style={{ borderColor: '#F7C1C1' }}>
        <div className="card-header">
          <span className="card-title" style={{ color: '#A32D2D' }}>Danger Zone</span>
        </div>
        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
          <button className="btn btn-sm" style={{ background: '#FCEBEB', color: '#A32D2D', border: '1px solid #F7C1C1' }}>
            Clear All Bookings Data
          </button>
          <button className="btn btn-sm" style={{ background: '#FCEBEB', color: '#A32D2D', border: '1px solid #F7C1C1' }}>
            Reset App Settings
          </button>
          <button className="btn btn-sm" style={{ background: '#FCEBEB', color: '#A32D2D', border: '1px solid #F7C1C1' }}>
            Export All Data (CSV)
          </button>
        </div>
      </div>
    </div>
  );
}
